/**
 * GLOBAL CONSTANTS
 */

export const PLAYGROUND_GITHUB_ISSUES_URL =
  'https://github.com/onflow/flow-playground/issues/new/choose';

export const HOTJAR_VERSION = 6;

export const CADENCE_DOCS_URL = 'https://docs.onflow.org/cadence';

export const LIGHT = 'light';
export const DARK = 'dark';
